"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useGeolocationMap: true,
  defaultViewport: true,
  useMap: true,
  useUserMap: true
};
Object.defineProperty(exports, "defaultViewport", {
  enumerable: true,
  get: function get() {
    return _useMap.defaultViewport;
  }
});
Object.defineProperty(exports, "useGeolocationMap", {
  enumerable: true,
  get: function get() {
    return _useGeolocationMap["default"];
  }
});
Object.defineProperty(exports, "useMap", {
  enumerable: true,
  get: function get() {
    return _useMap["default"];
  }
});
Object.defineProperty(exports, "useUserMap", {
  enumerable: true,
  get: function get() {
    return _useUserMap["default"];
  }
});

var _useClustering = require("./use-clustering");

Object.keys(_useClustering).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useClustering[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useClustering[key];
    }
  });
});

var _useGeolocationMap = _interopRequireDefault(require("./use-geolocation-map"));

var _useMap = _interopRequireWildcard(require("./use-map"));

var _useUserMap = _interopRequireDefault(require("./use-user-map"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }